import { createContainer } from 'react-sweet-state';

import { GenerationResultStore, PRIVATE_ACTIONS } from './GenerationResultStore';

export const GenerationResultStoreContainer = createContainer(GenerationResultStore, {
  onInit:
    () =>
    ({ setState, dispatch }, { state }) => {
      if (state) {
        setState(state);
      }
      dispatch(PRIVATE_ACTIONS.initStore());
    },
  onUpdate:
    () =>
    ({ setState, dispatch }, { state }) => {
      if (state) {
        setState(state);
      }
      dispatch(PRIVATE_ACTIONS.updateStore());
    },
});
